import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AdminNavbar from "./AdminNavbar";
import AdminSidebar from "./AdminSidebar";
import { selectIsViewingAsClient } from "../../../store/slices/authSlice";
import "./adminlayout.css";

export default function AdminLayout() {
  const isViewingAsClient = useSelector(selectIsViewingAsClient);

  // While an admin is "viewing as" a company's client side, the active identity
  // is a throwaway test member. Keep the admin panel sealed off so it never
  // renders under that identity — the only way back is "Exit to Admin", which
  // restores the real admin session.
  if (isViewingAsClient) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="dashboard" data-layout="dashboard">
      {/* Persistent admin sidebar on every page */}
      <AdminSidebar />

      {/* Right side: navbar + page content */}
      <div className="content-area">
        <AdminNavbar />
        <main className="main" data-layout="main">
          <div className="container-fluid" data-layout="container">
            {/* Child route content (AdminDashboard, Companies, Users, etc.) renders here */}
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
